var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAultPulseLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1138,
    height: 994,
    viewBox: "0 0 1138 994",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1981_691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.982 995.261C844.761 995.261 1067.51 772.509 1067.51 497.73C1067.51 222.951 844.761 0.198242 569.982 0.198242C295.203 0.198242 72.4502 222.951 72.4502 497.73C72.4502 772.509 295.203 995.261 569.982 995.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.701 529.034H569.967V566.085H405.654C413.428 553.735 421.184 541.384 428.923 529.034L429.01 528.894L569.984 308.297L709.631 528.894L709.718 529.034H709.701Z",
    fill: "url(#paint0_linear_1981_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.519 789.8L870.872 782.463L786.899 650.066H569.936V612.648H376.345C368.554 625.051 360.763 637.436 352.989 649.839C352.954 649.927 352.884 649.979 352.85 650.066L268.929 782.358L264.212 789.8H166.806C257.242 914.44 404.086 995.479 569.866 995.479C735.646 995.479 882.489 914.423 972.943 789.8H875.519ZM569.953 928.258C451.776 928.258 344.692 879.835 267.496 801.784L275.288 789.066C350.02 865.964 454.501 913.777 569.953 913.777C685.405 913.777 788.996 866.349 863.658 790.027L871.449 802.727C794.341 880.219 687.659 928.258 569.953 928.258Z",
    fill: "url(#paint1_linear_1981_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.508 649.826L190.433 660.622L180.948 675.121L136.594 742.831C119.999 713.553 106.286 682.423 95.8391 649.826H197.508Z",
    fill: "url(#paint2_linear_1981_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.96 649.826C1033.51 682.406 1019.78 713.553 1003.21 742.831L958.957 675.243L949.453 660.727L942.326 649.826H1043.98H1043.96Z",
    fill: "url(#paint3_linear_1981_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.147 91.6522L276.762 528.864H159.72C159.161 520.199 158.899 511.482 158.899 502.66C158.899 278.255 339.632 95.2683 563.164 91.6348L563.147 91.6522Z",
    fill: "url(#paint4_linear_1981_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.057 502.682C981.057 511.487 980.795 520.221 980.236 528.886H863.107L576.792 91.6567C800.324 95.2903 981.057 278.277 981.057 502.682Z",
    fill: "url(#paint5_linear_1981_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.64 497.741C1067.64 508.205 1067.31 518.581 1066.66 528.888H994.724C995.266 520.223 995.528 511.472 995.528 502.685C995.528 268.025 804.628 77.1251 569.968 77.1251C335.308 77.1251 144.425 268.025 144.425 502.685C144.425 511.472 144.687 520.223 145.229 528.888H73.1348C72.4884 518.599 72.1565 508.205 72.1565 497.741C72.1565 222.851 295.007 0 569.898 0C844.789 0 1067.64 222.851 1067.64 497.741Z",
    fill: "url(#paint6_linear_1981_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.915 612.648L197.546 649.839H95.8593C91.9288 637.646 88.47 625.226 85.5002 612.648H221.897H221.915Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.77 528.879L252.401 566.071H76.8206C75.1261 553.808 73.8858 541.405 73.1172 528.879H276.752H276.77Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.97 612.648V649.839H353.006C360.78 637.436 368.571 625.051 376.362 612.648H569.952H569.97Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.701 529.019H569.967V566.071H405.654C413.428 553.72 421.184 541.37 428.923 529.019L429.01 528.879H709.631L709.718 529.019H709.701Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.29 612.648C1051.32 625.243 1047.86 637.646 1043.95 649.839H942.299L917.929 612.648H1054.29Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.68 528.879C1065.91 541.405 1064.67 553.808 1062.98 566.071H887.484L863.132 528.879H1066.7H1066.68Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.76 106.145V93.5635H1058.54V106.145H1039.94V152.807H1025.58V106.145H1007.76ZM1097.03 152.807L1080.93 108.001V152.807H1067.35V93.5635H1088.16L1101.64 131.332L1115.04 93.5635H1136.11V152.807H1122.32V108.001L1106.03 152.807H1097.03Z",
    fill: "#373833"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1981_691",
    x1: 557.686,
    y1: 308.297,
    x2: 557.686,
    y2: 566.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1981_691",
    x1: 569.874,
    y1: 612.648,
    x2: 569.874,
    y2: 995.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1981_691",
    x1: 146.674,
    y1: 649.826,
    x2: 146.674,
    y2: 742.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1981_691",
    x1: 993.152,
    y1: 649.826,
    x2: 993.152,
    y2: 742.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1981_691",
    x1: 361.032,
    y1: 91.6348,
    x2: 361.032,
    y2: 528.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1981_691",
    x1: 778.924,
    y1: 91.6567,
    x2: 778.924,
    y2: 528.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1981_691",
    x1: 569.898,
    y1: 0,
    x2: 569.898,
    y2: 528.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1981_691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1137.12,
    height: 993.18,
    fill: "white",
    transform: "translate(0.184814)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAultPulseLogo);
export default __webpack_public_path__ + "static/media/ault_pulse_logo.51f4b14ee1c6900cd99e0c40bfc16636.svg";
export { ForwardRef as ReactComponent };